/* eslint-disable camelcase */
import { createSelector } from 'reselect';

export default createSelector(
  (state) => state.taxDocuments.payload,
  (payload) => {
    const { data, meta } = payload;

    if (!data || !data.length) {
      return { pageNumber: 1, perPage: 10, totalPages: 0, totalCount: 0, data: [] };
    }

    const {
      pageNumber: { current },
      perPage,
      totalPages,
      totalCount,
    } = meta;

    return {
      pageNumber: current,
      perPage,
      totalPages,
      totalCount,
      data: data.map(({ id, description, attributes: { name, year }, links: { downloadLink } }) => ({
        key: id,
        id,
        name,
        year,
        downloadLink,
        description,
      })),
    };
  },
);
